import httpAdminClient from '@/plugins/httpAdminClient';
import httpClient from '@/plugins/httpClient';

export default {
  getReserves(beginAt, endAt) {
    return httpClient.get(`meeting/reserves?begin_date=${beginAt}&end_date=${endAt}`);
  },
  createAppointment(data) {
    return httpAdminClient.post('admin/meeting/appointments', { meeting_appointment: { ...data } });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/meeting/bookingApis.js